import React, { useEffect, useState } from "react";
import {
  DetailFields,
  PageTitleComp,
  RightLayoutContainer,
  TableLayoutData,
} from "../../styledElements";
import { Button, Card, PageHeader, Space, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import GenericMatchingCriteriaDrawer from "./GenericMatchingCriteriaDrawer";
import {
  deleteStockMatchinggroup,
  getGenericStockMatchingData,
  getstockMatchingTableData,
} from "../../../Services/stockMatchingServices";
import GroupSideBar from "./GroupSidebar";
import { Styled } from "../../pageStyled";

export default function StockMatching() {
  const [
    visibleGenericMatchingCriteriaDrawer,
    setVisibleGenericMatchingCriteriaDrawer,
  ] = useState(false);
  const [genericMatchingCriteriaData, setGenericMatchingCriteriaData] =
    useState([]);
  const [intialGenericMatchingData,setInitialGenericMatchingData] = useState(null);
  const [stockMatchingTableData, setStockMatchingTableData] = useState([]);
  const [groupSidebarVisible,setGroupSidebarVisible] = useState(false);
  const [editGroup,setEditGroup] = useState(false);
  const [selectedRecord,setSelectedRecord] = useState(null);

  const onCloseGroupSidebar = () => {
    setGroupSidebarVisible(false);
    setEditGroup(false);
    setSelectedRecord(null);
    getstocktabledata();
  }
{console.log(genericMatchingCriteriaData)};
  const onCloseGenericMatchingCriteria = () => {
    setVisibleGenericMatchingCriteriaDrawer(false);
    fetchDataGenericStockdata();
  };
  const onEdit = (record) => {
    setEditGroup(true);
    setSelectedRecord({
      id: record?.key,
      group_name: record?.groupName,
      type: record?.type,
      grade: record?.grade,
      qualities: record?.qualities,
      gsm_lb: record?.gsmLower,
      gsm_ub: record?.gsmUpper,
      bulk_lb: record?.bulkLower,
      bulk_ub: record?.bulkUpper,
      bf_lb: record?.bfLower,
      bf_ub: record?.bfUpper,
      moisture_lb: record?.moistureLower,
      moisture_ub: record?.moistureUpper,
      accept_all_gsm: record?.acceptAllGsm,
      accept_all_bf: record?.acceptAllBf,
      accept_all_bulk: record?.acceptAllBulk,
      accept_all_moisture: record?.acceptAllMoisture,
      reel_size_lb: record?.reelSizeLower,
      reel_size_ub: record?.reelSizeUpper,
      sheet_size_lb: record?.sheetSizeLower,
      sheet_size_ub: record?.sheetSizeUpper,
      reel_size_unit: record?.reelUnit,
      sheet_size_unit: record?.sheetUnit,
    })
    setGroupSidebarVisible(true);
  };
  const onDelete = async(id) => {
    console.log("Delete record with ID:", id);
    try{
      await deleteStockMatchinggroup(id);
      await getstocktabledata();
    }
    catch(e)
    {
      console.log(e);
    }
  };
  
  const columns = [
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      width: 120,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 40,
      render: (value) =>(value.substring(0,1).toUpperCase()+value.substring(1,))
    },
    {
      title: "Grade",
      dataIndex: "grade",
      key: "grade",
      width: 70,
    },
    {
      title: "Qualities",
      dataIndex: "qualities",
      key: "qualities",
      width: 150,
      render: (qualities) =>{
        return(<Styled>
          {(qualities.length>2)?(
            <span>
              {`${qualities[0]}, ${qualities[1]} `}
              <Tooltip
                className="edit-tooltip"
                placement="bottomRight"
                title={qualities.join(", ")}
              >
                +{qualities.length-2} more
              </Tooltip>
            </span>):
            <span>{Array.isArray(qualities) ? qualities.join(", ") : "-"}</span>
          }
        </Styled>)
      }
    },

    // GSM
    {
      title: "GSM",
      key: "gsm",
      width: 140,
      render: (_, record) =>
        record.acceptAllGsm ? "All" : `-${record.gsmLower} to +${record.gsmUpper}`,
    },

    // Bulk
    {
      title: "Bulk",
      key: "bulk",
      width: 140,
      render: (_, record) =>
        record.acceptAllBulk
          ? "All"
          : `-${record.bulkLower} to +${record.bulkUpper}`,
    },

    // BF
    {
      title: "BF",
      key: "bf",
      width: 140,
      render: (_, record) =>
        record.acceptAllBf ? "All" : `-${record.bfLower} to +${record.bfUpper}`,
    },

    // Moisture
    {
      title: "Moisture",
      key: "moisture",
      width: 140,
      render: (_, record) =>
        record.acceptAllMoisture
          ? "All"
          : `-${record.moistureLower} to +${record.moistureUpper}`,
    },

    // Size (Dynamic: Reel/Sheet)
    {
      title: "Size",
      key: "size",
      width: 160,
      render: (_, record) => {
        if (record.type === "reel") {
          return record.reelSizeLower && record.reelSizeUpper
            ? `-${record.reelSizeLower} to +${record.reelSizeUpper} ${record.reelUnit || ""}`
            : "N/A";
        }

        if (record.type === "sheet") {
          return record.sheetSizeLower && record.sheetSizeUpper
            ? `-${record.sheetSizeLower} to +${record.sheetSizeUpper} ${record.sheetUnit || ""}`
            : "N/A";
        }

        return "N/A";
      },
    },

    // Actions
    {
      title: "Actions",
      key: "actions",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              className="edit-tooltip"
              title={"Edit this Group"}
            >
              <Button onClick={() => onEdit(record)}>
                <Iconmoon icon="edit" size={14}  color="#A19F9D"/>
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              className="edit-tooltip"
              title={"Delete this group"}
            >
              <Button danger onClick={() => onDelete(record.key)}>
                <Iconmoon icon="delete" size={14} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          
        </div>
      ),
    },
  ];

  const fetchDataGenericStockdata = async () => {
    try {
      const response = await getGenericStockMatchingData();
      setInitialGenericMatchingData({
        ...response,
        reel_size_unit:response?.units?.reel_size_lb,
        sheet_size_unit: response?.units?.sheet_size_lb,
      })
      setGenericMatchingCriteriaData([
        {
          label: "GSM Tolerance",
          value: "-"+response.gsm_lb + " to " +"+"+response.gsm_ub,
        },
        {
          label: "Bulk Tolerance",
          value: "-"+response.bulk_lb + " to " +"+"+response.bulk_ub,
        },
        {
          label: "BF Tolerance",
          value: "-"+response.bf_lb + " to " +"+"+response.bf_ub,
        },
        {
          label: "Moisture Tolerance",
          value: "-"+response.moisture_lb + " to " +"+"+response.moisture_ub,
        },
        {
          label: "Reel Size Tolerance",
          value: "-"+(response.reel_size_lb ?? 0) + " to " +"+"+(response.reel_size_ub ?? 0)+" " +response?.units?.reel_size_lb,
        },
        {
          label: "Sheet Size Tolerance",
          value:
            "-"+(response.sheet_size_lb ?? 0) + " to " +"+"+(response.sheet_size_ub ?? 0)+" " +response?.units?.sheet_size_lb
        },
      ]);
      console.log("response", response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const getstocktabledata = async () => {
    try {
      const response = await getstockMatchingTableData();
      console.log("response", response);
      const data = response.map((item) => ({
        key: item.id,

        groupName: item.group_name,
        type: item.type,
        grade: item.grade,

        qualities: item.qualities, // ["Q1", "Q2"]

        // GSM
        gsmLower: item.gsm_lb,
        gsmUpper: item.gsm_ub,
        acceptAllGsm: item.accept_all_gsm,

        // Bulk
        bulkLower: item.bulk_lb,
        bulkUpper: item.bulk_ub,
        acceptAllBulk: item.accept_all_bulk,

        // BF
        bfLower: item.bf_lb,
        bfUpper: item.bf_ub,
        acceptAllBf: item.accept_all_bf,

        // Moisture
        moistureLower: item.moisture_lb,
        moistureUpper: item.moisture_ub,
        acceptAllMoisture: item.accept_all_moisture,

        // Reel Size
        reelSizeLower: item.reel_size_lb,
        reelSizeUpper: item.reel_size_ub,
        reelUnit: item.units?.reel_size_lb || null,

        // Sheet Size
        sheetSizeLower: item.sheet_size_lb,
        sheetSizeUpper: item.sheet_size_ub,
        sheetUnit: item.units?.sheet_size_lb || null,

        // Meta
        createdAt: item.created_at,
        updatedAt: item.updated_at,

        eligibleStocks: item.eligible_stocks,
      }));
      setStockMatchingTableData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchDataGenericStockdata();
    getstocktabledata();
  }, []);
  return (
    <RightLayoutContainer>
      <DetailFields>
        <PageTitleComp style={{}}>
          <PageHeader
            // onBack={() => { history("../configurations") }}
            ghost={false}
            title="Matching Criteria"
            extra={[
              <Button
                key="1"
                className="themeBtn noBg"
                onClick={() => {
                  setVisibleGenericMatchingCriteriaDrawer(true);
                }}
              >
                <Iconmoon icon="edit" size={14} color="#EA655B" />
                Edit Matching Criteria
              </Button>,
              <Button
                key="2"
                className="themeBtn"
                onClick={() => {
                  setGroupSidebarVisible(true);
                }}
              >
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
                Add groups
              </Button>,
            ]}
          />
        </PageTitleComp>
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "20px",
            width: "100%",
            flexWrap: "noWrap",
            justifyContent: "space-between"
          }}
        >
          {genericMatchingCriteriaData?.map((item, index) => (
            <Card
              key={index}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                backgroundColor: "#F5F5F5",
                border: "1px solid #E1DFDD",
                width: "17%",
                height: "90px",
              }}
              bodyStyle={{
                padding:"18px"
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "column",
                  gap:"6px",
                  width: "100%",
                  height: "100%",
                }}
              >
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#EA655B",
                  }}
                >
                  {item.value}
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    textAlign:"center",
                    color: "#000000",
                  }}
                >
                  {item.label}
                </span>
              </div>
            </Card>
          ))}
        </div>
        <PageTitleComp style={{ borderBottom: "none", paddingBottom: "0px" }}>
          <PageHeader
            // onBack={() => { history("../configurations") }}
            ghost={false}
            title="Groups"
          />
        </PageTitleComp>
        <span style={{ color: "#605E5C" }}>
          Groups of similar qualities that can be used interchangeably
        </span>

        <TableLayoutData style={{ marginTop: "20px" }}>
          <div className="tableDataFormat">
            <Table
              columns={columns}
              dataSource={stockMatchingTableData}
              pagination={false}
              // scroll={{ x: 1500 }}
            />
          </div>
        </TableLayoutData>
        {visibleGenericMatchingCriteriaDrawer && <GenericMatchingCriteriaDrawer
          visible={visibleGenericMatchingCriteriaDrawer}
          onClose={onCloseGenericMatchingCriteria}
          initialData={intialGenericMatchingData}
        />}

        {groupSidebarVisible && <GroupSideBar
          visible={groupSidebarVisible} 
          onClose={onCloseGroupSidebar}
          editMode={editGroup}
          initialData={selectedRecord}
        />}

      </DetailFields>
    </RightLayoutContainer>
  );
}
